<template>
  <div class="case">
    <banner img="../assets/img/banner.png"
            title="产品中心" />
    <div class="case-section"
         v-loading="loading">
      <div class="case-section-content">
        <div class="case-section-content-list">
          <img v-lazy="imgFn(caseList[indexId].imgSrcName)" />
          <div class="content-list-abstract">
            <p class="abstract-title">{{caseList[indexId].Title}}</p>
            <div class="abstract-content price">
              简介：{{caseList[indexId].Content}}
              <p class="price">交付方式： 定制</p>
              <p class="price">
                价格：
                <span style="color:red">
                  {{caseList[indexId].price}}万元
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="price">
          <el-row type="flex"
                  justify="center"
                  :gutter="20">

            <el-col :span="5"
                    v-for="(item,index) in caseList[indexId].list"
                    :key="index">
              <el-card style=";height: 260px;">
                <div style="text-align:center">
                  <i style="font-size: 60px;color:blue;margin: 10px"
                     class="el-icon-setting"></i>
                </div>
                <div class="card-title">
                  {{item.title}}
                </div>
                <div>
                  {{item.name}}
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <img v-if="caseList[indexId]"
             class="detail-img"
             :src="detailImgFn(caseList[indexId].imgSrcName)"
             alt="">
      </div>

    </div>
  </div>
</template>
<script>
import Banner from '../components/Banner';
export default {
  components: {
    Banner,
  },
  data() {
    return {
      indexId: this.$route.query.id - 1,
      loading: false,
      caseList: [
        {
          imgSrcName: 'zf',
          price: '35',
          Title: '支付管理平台',
          Content: '提供商户号管理、账单管理、支付渠道管理、商户管理等功能和接口能力。',
          list: [
            { title: '多业务场景', name: '提供丰富且完善的业务能力接口，满足场景需要。' },
            { title: '多渠道支持', name: '支持多种支付渠道。' },
            { title: '快捷开发', name: '可通过接口快速完善业务开发。' },
          ],
        },
        {
          imgSrcName: 'lc',
          Title: '业务流程系统',
          price: '50',

          Content:
            '提供业务流程设计、表单服务、业务流程实例管理等能力接口，使开发者使用能力接口快速组装集成，实现流程审批等功能和接口。',
          list: [
            { title: '优化体验', name: '可支持可视化表单设计。' },
            { title: '节省成本', name: '提升规范，制定标准流程。' },
            { title: '提高效率', name: '减少人为干扰。' },
          ],
        },
        {
          imgSrcName: 'yp',
          Title: '内容管理平台',
          price: '100',

          Content: '提供音视频资讯管理服务是集成了资讯管理服务，音频管理服务，视频管理服务等模块功能和接口能力。',
          list: [
            { title: '统一管理', name: '提供丰富且完善的业务能力接口支持内容上架。' },
            { title: '内容审核', name: '可对接自动检测技术进行自动检测。' },
            { title: '快捷开发', name: '可通过接口快速完善业务开发。' },
          ],
        },
        {
          imgSrcName: 'wj',
          Title: '问卷调查平台',
          price: '100',
          Content:
            '包含问卷模板服务、问卷创建服务、问卷审核发布服务、问卷填写服务、问卷查询服务、问卷统计服务等模块功能和接口。',
          list: [
            { title: '多', name: '一次可以触达用户数量多，可以快速收集到一手数据。' },
            { title: '好', name: '通过问卷调查收集到的数据，较容易分析。' },
            { title: '省', name: '可以节约成本。' },
          ],
        },
        {
          imgSrcName: 'cl',
          Title: '车辆管理系统',
          price: '150',
          Content:
            '提供车辆档案管理、驾驶员档案管理、用车审核管理、车辆出车/收车管理、车辆加油管理、车辆维修管理、车辆保养管理、车辆年检管理、统计报表等功能和api能力。',
          list: [
            { title: '流程清晰', name: '能使工作流程更加清晰。' },
            { title: '提高效率', name: '通过清晰的申请、审批、调度、出车、回车、统计汇总分析工作流程提高工作效率。' },
            { title: '节约管理成本', name: '强化管理手段和工作效率，提高经营管理水平，实现有效节约车辆管理成本。' },
          ],
        },
        {
          imgSrcName: 'sb',
          Title: '设备维保管理系统',
          price: '250',
          Content:
            '提供设备管理，设备备件管理，点巡检管理，设备维修保养，流程引用，个人中心，系统管理，数据源管理等功能和接口能力。',
          list: [
            { title: '科学管理', name: '管理设备信息，简历设备档案。' },
            { title: '提高可靠性', name: '涵盖了设备维保需求，以确保设备的可靠性。' },
            { title: '持续发展', name: '提高设备可靠性和性能促进业务运营持续发展。' },
          ],
        },
        {
          imgSrcName: 'ywzt',
          Title: '业务中台',
          price: '1000',
          Content:
            '业务中台将分散的业务能力以统一形式沉淀为各种服务中心，为应用的研发和平台运营提供统一业务服务。支撑移动应用的敏捷开发、在线验证、快速上线及应用的快速创新。中台服务管理是服务的运行管理平台。基础服务提供基础服务能力。',
          list: [
            { title: '统一纳管', name: '对服务统一纳管，进行标准化封装，并保障服务安全稳定运行。' },
            { title: '统一监控', name: '对纳管服务，基于成熟的监控技术和链路追踪技术对服务和访问进行监控，并保障服务安全稳定运行。' },
            { title: '统一发布', name: '通过API开放平台对外发布服务接口，并支持服务能力的平滑升级。' },
          ],
        },
        {
          imgSrcName: 'yxzpt',
          Title: '云协作',
          price: '20',
          Content:
            '“云协作”提供办公协作、业务权限管理、成果共享等功能。',
          list: [
            { title: '云存储', name: '提供企业所需的海量云端存储空间；没有内部服务器的高维护成本，支持随时扩容。' },
            { title: '空间隔离', name: '个人、部门、协作多种独立文档存储空间，各个文档空间隔离，。' },
            { title: '有序管理', name: '构建企业资料库，文件归档，有序管理文档分类，沉淀企业知识精华。' },
          ],
        },
        {
          imgSrcName: 'iot',
          Title: 'IOT平台',
          price: '30',
          Content:
            '自研平台，并自研DTU设备可兼容多个品牌和类型的控制器，并与控制器深度整合（读/写全可控）。',
          list: [
            { title: '实时监控', name: '告警信息及时推送到移动端，最大程度避免出现货损，确保食品安全。' },
            { title: '兼容性强', name: '自研DTU，可兼容多个品牌和类型的控制器。' },
            { title: '报表丰富', name: '丰富多样的KPI报表（温度/告警/能耗），辅助企业精细化运营和管理。' },
          ],
        },
        {
          imgSrcName: 'ai',
          Title: '机器学习平台',
          price: '200',
          Content: '提供一站式AI模型开发功能，通过智能数据处理，模型开发和模型训练，打通深度学习全链路。平台预置了一系列汉卓自主研发针对指定应用场景的算法，例如图像识别、故障预测、性能预测等。',
          list: [
            { title: '一站式开发', name: '为用户提供一站式AI模型开发功能，通过智能数据处理，模型开发和模型训练，打通深度学习全链路。' },
            { title: '安全稳定', name: '基于k8s容器化资源，用户资源与环境隔离，独立、安全、稳定。' },
            {
              title: '私有化交付',
              name: '保障企业核心生产数据私密性和安全性。',
            },
          ],
        },
        {
          imgSrcName: 'cv',
          Title: 'CV视觉处理平台',
          price: '150',
          Content:
            '基于计算机视觉技术，对图像分类、物体检测、图像分割、场景理解、人脸识别、姿态估计、光流估计、立体视觉。应用于图像搜索、图像自动标记、目标识别和物体检测、视觉监控和安防、医学图像识别、自动驾驶、农业图像分析。',
          list: [
            { title: '效率高', name: '在实时性要求较高的应用中，系统的速度和效率至关重要。通过快速处理大量图像和视频数据，能够迅速响应并满足应用需求。' },
            { title: '精度高', name: '通过自动化执行视觉任务，系统可以大大提高工作效率，减少人为错误。同时，其高精度分析能力使得系统在各种应用中都能提供准确可靠的结果。' },
            {
              title: '多样性高',
              name: '能够适应各种复杂场景和需求。无论是工业自动化、医疗诊断还是智能交通等领域，都能提供有效的解决方案。',
            },
          ],
        },
        {
          imgSrcName: 'order',
          Title: '订单管理系统',
          price: '30',
          Content: '系统支持pc端和pad端，功能包括订单管理、订单确认、用餐管理、收银管理、采买管理、客户管理、报表管理、系统管理等功能。',
          list: [
            { title: '全周期', name: '从前台下单、确认、用餐、收银，到后台库存采买，联动协同。' },
            { title: '丰富报表', name: '提供销售报表、成本&费用报表、利润报表、现金流量表等。' },
            {
              title: '多终端支持',
              name: '支持pc端、pad端，支持多打印机。',
            },
          ],
        }
      ],
    };
  },
  watch: {
    '$route.query.id'() {
      this.indexId = this.$route.query.id - 1;
    },
  },
  methods: {
    imgFn(name) {
      return require(`../assets/kz/${name}.png`);
    },
    detailImgFn(name) {
      return require(`../assets/kz/detail/${name}.jpg`);
    },
  },
};
</script>

 <style lang="scss" scoped>
.case {
  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        // border: 1px solid pink;

        img {
          width: 280px;
          height: 180px;
        }
        .content-list-abstract {
          width: 500px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            color: #484848;
            font-size: 15px;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        // .abstract-active {
        //   order: -1;
        // }
      }
    }
  }
}
.price {
  margin-top: 10px;
}
.detail-img {
  width: 850px;
  display: flex;
  margin: 20px auto;
  margin-bottom: 40px;
}
.card-title {
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  margin: 10px 0 15px;
}
</style>